// ABOUTME: The layout route around the authenticated pages: renders the page, and under it the bottom navigation
// ABOUTME: for a signed-in talent on anything but a full-screen flow, padding the page so nothing sits under the bar.
import { Outlet, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import Box from '@mui/material/Box';
import { NAV_FREE_PATHS, NAV_HEIGHT } from '../constants';
import { Footer } from './Footer';

const isNavFree = (pathname: string): boolean =>
  NAV_FREE_PATHS.some(
    path => pathname === path || pathname.startsWith(`${path}/`)
  );

export const BottomNavShell = () => {
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth0();

  const showNav = isAuthenticated && !isNavFree(pathname);

  return (
    <>
      {/* An inline style rather than sx so the padding is a fact of the DOM, not of a stylesheet a test cannot read. */}
      <Box
        data-testid="bottom-nav-shell"
        style={
          {
            paddingBottom: showNav ? NAV_HEIGHT : 0,
            // Fixed bars inside the page (the floating actions) read this to dock above the navigation instead of under it.
            '--bottom-nav-height': showNav ? `${NAV_HEIGHT}px` : '0px'
          } as React.CSSProperties
        }
      >
        <Outlet />
      </Box>
      {showNav && <Footer />}
    </>
  );
};
